import { Fragment } from 'react';
import PropTypes from 'prop-types';
import Link from '@/components/Link';
import EventCategories from './EventCategories';

const EventBreadcrumbDivider = () => (
  <div className="text-gray-400">
    <svg
      className="w-4 h-4 fill-current"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
        clipRule="evenodd"
      />
    </svg>
  </div>
);

const defaultProps = {
  title: null,
  uri: null,
  showEventPage: false,
  categories: [],
};

const propTypes = {
  title: PropTypes.string,
  uri: PropTypes.string,
  showEventPage: PropTypes.bool,
  categories: PropTypes.arrayOf(PropTypes.object),
};

export default function EventBreadcrumb({
  title,
  uri,
  showEventPage,
  categories,
}) {
  const hasCategory = categories && categories.length !== 0;

  return (
    <div className="flex items-center space-x-1 max-w-full overflow-x-auto pb-4 md:pb-0">
      <Link href="/eventos" className="font-medium text-green-500">
        Eventos
      </Link>
      {showEventPage && (
        <Fragment>
          <EventBreadcrumbDivider />
          <Link
            href={uri}
            className="font-medium text-green-500 whitespace-nowrap"
          >
            {title}
          </Link>
        </Fragment>
      )}

      {hasCategory && (
        <Fragment>
          <EventBreadcrumbDivider />
          <EventCategories categories={categories} />
        </Fragment>
      )}
    </div>
  );
}

EventBreadcrumb.defaultProps = defaultProps;
EventBreadcrumb.propTypes = propTypes;
